import Button, { ButtonProps } from 'components/button';
import styles from './styles.module.scss';

type ClearInputButtonProps = Pick<ButtonProps, 'onClick'>;

const ClearInputButton: React.FC<ClearInputButtonProps> = (props) => {
  return <Button {...props} className={styles.button} variant='transparent' label='Очистить' />;
};

export default ClearInputButton;
